module.exports = __webpack_public_path__ + "img/header-engagementRings070Carat@2x.24351b7.webp";